import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import ModalContainer from '../../ModalContainer/ModelContainer'
import TextField from '../../FormLegacy/FormFieldsV2/TextField'

const SaveAsTemplateModal = ({
  onClose = () => {},
  onSubmit = () => {},
  handleChange = () => {},
  value,
}) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  return (
    <ModalContainer
      additionalClass="internal-inspections-modal"
      onClose={onClose}
      headerTitle={t('internal-inspections:saveAsTemplateModal.title')}
    >
      <div className="inspections-modal-content">
        <TextField
          name="templateName"
          onChange={handleChange}
          value={value}
          placeholder={t('internal-inspections:templateView.enterTemplateNamePlaceholder')}
          label={t('internal-inspections:templateView.templateName')}
        />
      </div>
      <div className="inspections-modal-actions">
        <button className="button button-gray" onClick={onClose}>
          {t('common:actions.cancel')}
        </button>
        <button className="button button-black" type="button" disabled={!value} onClick={onSubmit}>
          {t('internal-inspections:templateNavbar.saveTemplate')}
        </button>
      </div>
    </ModalContainer>
  )
}

SaveAsTemplateModal.propTypes = {
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  value: PropTypes.string,
}

export default SaveAsTemplateModal
